import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const ModalStudyMonitors = ({ closeModal, openModal, dataMonitor, idStudy, refresh }) => {

    const defaultMaterialTheme = createMuiTheme({
        palette: {
            primary: {
                main: '#3EA3FC',
                contrastText: "#fff"
            },

        },
    });

    //Loader
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");
    const [users, setUsers] = React.useState([]);
    const [userMonitor, setUserMonitor] = React.useState(null);
    const [startDate, setStartDate] = React.useState(null);
    const [finalDate, setFinalDate] = React.useState(null);

    const listUsers = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}usuario/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(response => response.json()).then(data => {
            setUsers(data);
        }).catch(err => {
            setUsers([]);
        });
    }

    const onOk = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            refresh();
            closeModal();
        }
    }

    const createMonitor = async () => {
        let dataSend = {
            fecha: moment(startDate).format('YYYY-MM-DD'),
            id_estudio: idStudy,
            fecha_final: moment(finalDate).format('YYYY-MM-DD'),
            id_usuario: userMonitor
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'monitorese/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error vinculando el Monitor al Estudio Clinico");
            }
        }).then(response => {
            setAlertColorModal("success");
            setAlertMessageModal("El Monitor se ha vinculado al estudio correctamente");
            setAlerShowModal(true);
        }).catch(err => {
            console.log(err);
            setAlertColorModal("danger");
            setAlertMessageModal("Ha ocurrido un error vinculando el Monitor al estudio");
            setAlerShowModal(true);
        })
    }

    const updateMonitor = async () => {
        let dataSend = {
            fecha: moment(startDate).format('YYYY-MM-DD'),
            fecha_final: moment(finalDate).format('YYYY-MM-DD'),
            id_monitor:dataMonitor.id_monitor
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'monitorese/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error actualizando el Monitor del Estudio Clinico");
            }
        }).then(response => {
            setAlertColorModal("success");
            setAlertMessageModal("El Monitor se ha actualizado correctamente en el estudio clinico");
            setAlerShowModal(true);
        }).catch(err => {
            console.log(err);
            setAlertColorModal("danger");
            setAlertMessageModal("Ha ocurrido un error actualizando el Monitor en el estudio clinico");
            setAlerShowModal(true);
        })
    }

    const sendFieldsMonitor = () => {
        if(dataMonitor != null && dataMonitor != undefined)
        {
            setUserMonitor(dataMonitor.id_usuario);
            setStartDate(dataMonitor.fecha);
            setFinalDate(dataMonitor.fecha_final);
        }
    }

    React.useEffect(() => {
        listUsers();
        sendFieldsMonitor();
    }, []);

    return (
        <div>
            <Modal
                open={openModal}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {
                                dataMonitor != null && dataMonitor != undefined ?
                                    <h5 className="bold-text">Actualizar Monitor</h5>
                                    :
                                    <h5 className="bold-text">Agregar Monitor</h5>
                            }
                        </div>
                        <Row>
                            <Col md={4}>
                                <TextField
                                    id="select_usuario"
                                    select
                                    disabled={dataMonitor != null && dataMonitor != undefined ? true : false}
                                    label="Usuario"
                                    value={userMonitor}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setUserMonitor(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%', borderColor: 'black', marginTop: 5 }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    {users.map((user, index) => {
                                        return <MenuItem key={index} value={user.id_usuario}>{user.nombre_usuario}</MenuItem>
                                    })}
                                </TextField>
                            </Col>
                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <DatePicker
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                            autoOk={true}
                                            variant="inline"
                                            label="Fecha Inicial"
                                            views={["year", "month", "date"]}
                                            value={startDate}
                                            onChange={(date) => {
                                                setStartDate(date);
                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/DD"
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <DatePicker
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                            autoOk={true}
                                            variant="inline"
                                            label="Fecha Final"
                                            views={["year", "month", "date"]}
                                            value={finalDate}
                                            onChange={(date) => {
                                                setFinalDate(date);
                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/DD"
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            dataMonitor == null ? <Button
                                disabled={false}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    createMonitor()
                                }}
                            >
                                Crear
                            </Button>
                                :
                                <Button
                                    disabled={false}
                                    style={{ marginTop: 10, marginRight: 10 }}
                                    variant="contained"
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => {
                                        updateMonitor();
                                    }}
                                >
                                    Actualizar
                                </Button>
                        }
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOk(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalStudyMonitors;
